import React, { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import useModal from '../../../../../../Components/CustomModal/useModal';
import ManualPoModel from './ManualPoModel';
import AutoPoModel from './AutoPoModel';
import Swal from 'sweetalert2';
import axios from 'axios';
import { V_URL } from '../../../../../../BaseUrl';
import { Pencil, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { getViewPoItems } from '../../../../../../Store/prosafe/proTransaction/PurOrder/getViewPoItems';

const PurPoItems = ({ itemsArr, setItemsArr, data, form }) => {

    const [activeModal, setActiveModal] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [editItemId, setEditItemId] = useState(null);
    const modal = useModal();
    const dispatch = useDispatch();

    const itemsType = itemsArr.length > 0 ? itemsArr[0].isAuto ? 'auto' : 'manual' : null;

    const handleEdit = (index) => {
        setEditingIndex(index);
        setEditItemId(itemsArr[index]._id);
        setActiveModal('manual');
        modal.show();
    };

    const handleDelete = async (index, itemName) => {
        Swal.fire({
            title: `Are you sure? Delete ${itemName}`,
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const itemToDelete = itemsArr[index];
                if (data?._id && itemToDelete?._id) {
                    try {
                        const payload = {
                            id: data._id,
                            itemId: itemToDelete._id,
                        };
                        await axios({
                            method: "put",
                            url: `${V_URL}/prosafe/pro-delete-po-item`,
                            data: payload,
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
                            },
                        });
                        dispatch(getViewPoItems({ formData: { id: data?._id } }));
                        Swal.fire('Deleted!', 'The item has been deleted.', 'success');
                    } catch (error) {
                        Swal.fire('Error!', 'Failed to delete item.', 'error');
                        console.error('Delete error:', error);
                    }
                } else {
                    const updatedItems = [...itemsArr];
                    updatedItems.splice(index, 1);
                    setItemsArr(updatedItems);
                    Swal.fire('Deleted!', 'The item has been deleted.', 'success');
                }
            }
        });
    };

    const handleSubmit = (itData) => {
        if (editingIndex !== null) {
            const updatedItems = [...itemsArr];
            updatedItems[editingIndex] = itData;
            setItemsArr(updatedItems);
            setEditingIndex(null);
        } else {
            if (itemsArr.length > 0 && itemsArr[0].isAuto !== itData.isAuto) {
                toast.error("Cannot mix auto and manual items in the same order");
                return;
            }
            setItemsArr([...itemsArr, itData]);
        }
    };

    const itemData = useSelector((state) => state.getItem?.user?.data) || [];

    const getItemName = (itemId) => {
        const item = itemData.find(item => item._id === itemId);
        return item ? item.name : 'N/A';
    };

    const showAutoButton = itemsArr.length === 0 || (itemsArr.length > 0 && itemsArr[0].isAuto);
    const showManualButton = itemsArr.length === 0 || (itemsArr.length > 0 && !itemsArr[0].isAuto);

    const totals = useMemo(() => {
        return itemsArr?.reduce(
            (acc, item) => {
                acc.quantity += Number(item.quantity) || 0;
                acc.amount += Number(item.amount) || 0;
                acc.total_amount += Number(item.total_amount) || 0;
                acc.discount_amount += Number(item.discount_amount) || 0;
                acc.taxable_amount += Number(item.taxable_amount) || 0;
                acc.gst_amount += Number(item.gst_amount) || 0;
                return acc;
            },
            {
                quantity: 0,
                amount: 0,
                total_amount: 0,
                discount_amount: 0,
                taxable_amount: 0,
                gst_amount: 0,
            }
        );
    }, [itemsArr]);

    return (
        <div className='row'>
            <div className='col-md-12'>
                <div className="card">
                    <div className="card-body">
                        <div className="col-12 d-flex justify-content-between align-items-center mb-4">
                            <div className="d-flex gap-2 align-items-center">
                                <h4>Items Details List</h4>
                                {(!form?.party_id || !form.project_id) && (
                                    <span className="alert alert-warning p-2">Please select the party and project for adding the items.</span>
                                )}
                                {itemsType && (
                                    <span className="alert alert-info p-2">
                                        Current items are {itemsType} type
                                    </span>
                                )}
                            </div>
                            {form?.party_id && form.project_id && (
                                <div className="add-group">
                                    {showAutoButton && (
                                        <button
                                            type="button"
                                            className="btn btn-primary add-pluss ms-2 w-100"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            onClick={() => {
                                                setActiveModal('auto');
                                                modal.show();
                                            }}
                                            title="Add Auto"
                                        >
                                            Auto
                                            <img src="/assets/img/icons/plus.svg" alt="add-icon" className='mx-1' />
                                        </button>
                                    )}
                                    {showManualButton && (
                                        <button
                                            type="button"
                                            className="btn btn-primary add-pluss ms-2 w-100"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            onClick={() => {
                                                setActiveModal('manual');
                                                modal.show();
                                            }}
                                            title="Add Manual"
                                        >
                                            Manual
                                            <img src="/assets/img/icons/plus.svg" alt="add-icon" className='mx-1' />
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="table-responsive">
                            <table className="table border-0 mb-0 custom-table table-striped comman-table">
                                <thead>
                                    <tr>
                                        <th>Sr.</th>
                                        <th>Item Name</th>
                                        <th>Item No.</th>
                                        {/* <th>Length(mm)</th>
                                        <th>Width(mm)</th> */}
                                        {/* <th>Weight(kg)</th> */}
                                        {/* <th>Assem. Weight(kg)</th>
                                        <th>ASM(sqm)</th> */}
                                        <th>PO Qty</th>
                                        <th>Original Rate(₹)</th>
                                        <th>Purchase Rate(₹)</th>
                                        <th>Amount(₹)</th>
                                        <th>Discount(%)</th>
                                        <th>Discount Amount(₹)</th>
                                        <th>Taxable Amount(₹)</th>
                                        <th>GST(%)</th>
                                        <th>GST Amount(₹)</th>
                                        <th>Total Amount(₹)</th>
                                        <th>Type</th>
                                        <th>Remarks</th>
                                        <th className="text-end">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {itemsArr?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{getItemName(item.item_id)}</td>
                                            <td>{item.item_no || "-"}</td>
                                            {/* <td>{item.item_length || '-'}</td>
                                            <td>{item.item_width || '-'}</td> */}
                                            {/* <td>{item.item_weight || '-'}</td> */}
                                            {/* <td>{item.assembly_weight || '-'}</td>
                                            <td>{item.assembly_surface_area || '-'}</td> */}
                                            <td>{item.quantity ?? '-'}</td>
                                            <td>{item.mrp ? Number(item.mrp).toFixed(2) : '-'}</td>
                                            <td>{item.rate ? Number(item.rate).toFixed(2) : '-'}</td>
                                            <td>{item.amount ? Number(item.amount).toFixed(2) : '-'}</td>
                                            <td>{item.discount ? Number(item.discount) : '-'}</td>
                                            <td>{item.discount_amount ? Number(item.discount_amount).toFixed(2) : '-'}</td>
                                            <td>{item.taxable_amount ? Number(item.taxable_amount).toFixed(2) : '-'}</td>
                                            <td>{item.gst ? Number(item.gst) : '-'}</td>
                                            <td>{item.gst_amount ? Number(item.gst_amount).toFixed(2) : '-'}</td>
                                            <td>{item.total_amount ? Number(item.total_amount).toFixed(2) : '-'}</td>
                                            <td>{item.isAuto ? "Auto" : "Manual" || '-'}</td>
                                            <td>{item.remarks || '-'}</td>
                                            {/* {item.status === true ? ( */}
                                            <td className="d-flex justify-content-end">
                                                <a className='action-icon mx-1' style={{ cursor: "pointer" }}
                                                    data-toggle="tooltip" data-placement="top" title="Edit"
                                                    onClick={() => handleEdit(index)}
                                                >
                                                    <Pencil />
                                                </a>
                                                <a className='action-icon mx-1' style={{ cursor: "pointer" }}
                                                    data-toggle="tooltip" data-placement="top" title="Delete"
                                                    onClick={() => handleDelete(index, getItemName(item.item_id))}
                                                >
                                                    <Trash2 />
                                                </a>
                                            </td>
                                            {/* ) : <td>-</td>} */}
                                        </tr>
                                    ))}
                                    {itemsArr?.length > 0 && (
                                        <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                                            <td colSpan="2" className="text-left" style={{ padding: "0 35px" }}>Total</td>
                                            <td>-</td>
                                            <td>{totals.quantity}</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>{totals.amount.toFixed(2)}</td>
                                            <td>-</td>
                                            <td>{totals.discount_amount.toFixed(2)}</td>
                                            <td>{totals.taxable_amount.toFixed(2)}</td>
                                            <td>-</td>
                                            <td>{totals.gst_amount.toFixed(2)}</td>
                                            <td>{totals.total_amount.toFixed(2)}</td>
                                            <td>-</td>
                                            <td colSpan="3"></td>
                                        </tr>
                                    )}
                                    {itemsArr?.length === 0 ? (
                                        <tr>
                                            <td colSpan="999">
                                                <div className="no-table-data">
                                                    No Data Found!
                                                </div>
                                            </td>
                                        </tr>
                                    ) : null}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
            {activeModal === 'manual' && (
                <ManualPoModel
                    itemsArr={itemsArr}
                    editingIndex={editingIndex}
                    setEditingIndex={setEditingIndex}
                    data={data}
                    onSubmit={handleSubmit}
                    modal={{
                        ...modal,
                        onClose: () => {
                            modal.hide();
                            setActiveModal(null);
                            setEditingIndex(null);
                            setEditItemId(null);
                        }
                    }}
                    editItemId={editItemId}
                    setEditItemId={setEditItemId}
                />
            )}

            {activeModal === 'auto' && (
                <AutoPoModel
                    modal={{
                        ...modal,
                        onClose: () => {
                            modal.hide();
                            setActiveModal(null);
                        }
                    }}
                    setItemsArr={setItemsArr}
                    itemsArr={itemsArr}
                    form={form}
                    data={data}
                />
            )}
        </div>
    )
}

export default PurPoItems